// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__wqNTI","primary":"Button_primary__uAv0y"};